// Aplica al documento el branding del APR. Se llama desde src/index.js solo
// cuando la config es válida.
//
// El manifest PWA NO se toca acá: lo sirve nginx en /manifest.webmanifest.
// Armarlo en el browser con un blob: URL no funciona — un blob: URL es
// cannot-be-a-base, así que los src relativos de los íconos no resuelven, y
// WebKit procesa el <link rel="manifest"> durante el parseo del documento,
// antes de que corra este código.
function applyBranding(config) {
    document.title = config.aprName;

    const setAttr = (selector, attr, value) => {
        const el = document.querySelector(selector);
        if (el) el.setAttribute(attr, value);
    };

    setAttr('link[rel="icon"]', 'href', config.aprFavicon);

    // iOS no lee el manifest para esto: usa apple-touch-icon, que además toma
    // precedencia sobre los íconos del manifest. Safari lee el DOM al momento
    // de "Agregar a inicio", que ocurre después de esta línea.
    setAttr('link[rel="apple-touch-icon"]', 'href', config.aprIcon);
    setAttr('meta[name="apple-mobile-web-app-title"]', 'content', config.aprName);
}

export default applyBranding;
